import styled from '@emotion/styled';

export default styled('div')`
  display: flex;
  flex-wrap: wrap;
  margin: -6px;
  > * {
    margin: 6px;
  }
`;
